if (!customElements.get('variant-details')) {
  customElements.define(
    'variant-details',
    class VariantDetails extends HTMLElement {
      variantChangeUnsubscriber = undefined;
      abortController = undefined;

      constructor() {
        super();
      }

      connectedCallback() {
        // Subscribe to variant change events
        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        this.abortController?.abort();
      }

      handleVariantChange({ data: { variant } }) {
        if (!variant || !variant.id) return;

        // Only update if this section is on the same product page
        const productId = this.dataset.productId;
        if (!productId) return;

        // Fetch the section with the variant parameter
        this.updateSection(variant.id);
      }

      async updateSection(variantId) {
        // Abort any pending requests
        this.abortController?.abort();
        this.abortController = new AbortController();

        const sectionId = this.dataset.section;
        if (!sectionId) return;

        // Build the URL with section_id and variant parameter
        // The section rendering API will use the variant parameter to render the correct content
        const url = `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`;

        try {
          const response = await fetch(url, { signal: this.abortController.signal });
          if (!response.ok) return;

          const html = await response.text();
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
          const newSection = parsedHtml.querySelector(`variant-details[data-section="${sectionId}"]`);

          if (newSection) {
            // Update the section content
            this.innerHTML = newSection.innerHTML;
            
            // Update visibility based on whether content exists
            const hasContent = newSection.innerHTML.trim() !== '';
            if (hasContent) {
              this.removeAttribute('hidden');
            } else {
              this.setAttribute('hidden', '');
            }
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Error updating variant details:', error);
          }
        }
      }
    }
  );
}

